import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const state = {}

const getters = {}

const mutations = {}

const actions = {}

const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    strict: debug,
    modules
})

export default store
